import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'appkit-react';
import { insightModals, INSIGHT_FIELDS } from '@model';
import { connect } from 'react-redux';
import {
  filterDisplayablePrinciples,
  formatCardData,
  getToggleModalByRef,
} from '@modules/insights/guidingPrincipleCards';
import InsightModal from '../../analysis/insightModal';
import Card from '../../insights/card';
import actions from '@flux/action';
import '../../../styles/components/card.scss';
import '../../../styles/modules/project/guidingPrinciplesDrawer.scss';
import { useLocation } from 'react-router-dom';

const { G_PRINCIPLES_FORM } = insightModals;

const GdPcps = (props) => {
  const { fetchData, projectId, principleData, companyInstance } = props;
  const location = useLocation();

  const [data, setData] = useState([]);
  const [hasLoaded, setHasLoaded] = useState(false);

  const modalRef = useRef(null);
  const toggleModal = getToggleModalByRef(modalRef);
  const isClient = JSON.parse(window.localStorage.userInfo || '{}')?.isClient;

  useEffect(() => {
    if (location.state?.preventRefresh || !companyInstance) {
      return undefined;
    }
    setHasLoaded(false);
    const load = fetchData(projectId, companyInstance);
    if (load && typeof load.finally === 'function') {
      load.finally(() => setHasLoaded(true));
    } else {
      setHasLoaded(true);
    }
    return undefined;
  }, [companyInstance, projectId, location.state?.preventRefresh]);

  useEffect(() => {
    const displayable = filterDisplayablePrinciples(principleData);
    setData(formatCardData(displayable, toggleModal));
  }, [principleData]);

  const showEmptyState = hasLoaded && data.length === 0;

  const renderContent = () => {
    if (!hasLoaded) {
      return null;
    }

    if (showEmptyState) {
      return (
        <div className="gp-principles-empty" role="status">
          <p className="gp-principles-empty__title">
            No guiding principles to show
          </p>
          <p className="gp-principles-empty__description">
            {isClient
              ? 'Guiding principles for this project have not been published yet.'
              : 'Add guiding principles for this project using Add New above, or the button below.'}
          </p>
          {isClient ? null : (
            <Button
              size="lg"
              className="add-principle-button role-control"
              onClick={toggleModal(G_PRINCIPLES_FORM)}
            >
              Add guiding principle
            </Button>
          )}
        </div>
      );
    }

    return data.map((value) => (
      <Card
        key={value.id || value.title}
        variant="drawer"
        title={value.title}
        content={value.content}
        cate={value.cate}
        action={value.action}
        insight={value.insight}
        withTooltip={false}
      />
    ));
  };

  return (
    <>
      <InsightModal
        ref={modalRef}
        rootNode=".app-content"
        field={INSIGHT_FIELDS.PRINCIPLE}
        shouldShowGoBack={false}
        disableScroll
        modalBodyClassName="homepage-left"
        companyInstance={companyInstance}
        closeModalCallback={() => fetchData(projectId, companyInstance)}
      />
      <div className="collapse-header">
        <span>Guiding Principles</span>
        {isClient ? null : (
          <Button
            size="lg"
            className="add-principle-button role-control"
            onClick={toggleModal(G_PRINCIPLES_FORM)}
          >
            Add New
          </Button>
        )}
      </div>
      <div className="guiding-principles-project-detail">
        {renderContent()}
      </div>
    </>
  );
};

const mapStateToProps = ({ common, insights, projects, login }) => {
  const projectId = common.currentId;
  const { principleData = [] } = insights.insightsData[projectId] || {};
  return {
    principleData,
    projectId,
    permission: projects.sectionsPermission.insightPermission,
    userInfo: login.userInfo || {},
    companyInstance: common?.projectCompanyInfo?.companyInstance,
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchData(projectId, companyInstance) {
    return dispatch(
      actions.fetchGdPrincipleAndInsightstData(projectId, companyInstance),
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(GdPcps);
